import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingStateService {
  private readonly isLoadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();

  constructor() { }

  /**
   * Inicia el proceso de carga (ocultará el stepper)
   */
  startLoading(): void {
    this.isLoadingSubject.next(true);
  }

  /**
   * Detiene el proceso de carga (mostrará el stepper)
   */
  stopLoading(): void {
    this.isLoadingSubject.next(false);
  }

  /**
   * Obtiene el estado actual de carga
   */
  getLoadingState(): boolean {
    return this.isLoadingSubject.value;
  }
}
